import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { RestService } from '../providers/rest.service';
import { StokListePage } from '../model/stok-liste-page';
import { StokListe } from '../model/stok-liste';
import { ActivatedRoute, Router } from '@angular/router';
import { TalepKalem } from '../model/talep-kalem';
import { UrunGrup } from '../model/urun-grup';
import { Subscription } from 'rxjs';
import { Talep } from '../model/talep';
import { TalepOnaylaRequest } from '../model/talep-onayla-request';
import { TalepTalepOnaySeviye } from '../model/talep-talep-onay-seviye';
import { CariListePage } from '../model/cari-liste-page';
import { Cari } from '../model/cari';
import { Master } from '../model/master';
import { TeklifOlusturRequest } from '../model/teklif-olustur-request';
import { Teklif } from '../model/teklif';
import { Sube } from '../model/sube';
import { TalepTur } from '../model/talep-tur';
import { TalepGorsel } from '../model/talep-gorsel';
import { TalepKaydetRequest } from '../model/talep-kaydet-request';
import { MailRequest } from 'src/model/mail-request';
import { ToastrService } from 'ngx-toastr';
import { TalepAciklama } from 'src/model/talep-aciklama';
import { TeklifComponent } from 'src/teklif/teklif.component';
import { Pair } from 'src/model/pair';

declare var $: any;

@Component({
  selector: 'app-talep',
  templateUrl: './talep.component.html',
  styleUrls: ['./talep.component.css']
})
export class TalepComponent implements OnInit, OnDestroy {
  id = '0';
  talep: Talep = new Talep();
  showSearchResultCount = 10;
  showSearchResultCountCari = 10;
  showSearchResultCountModel: number[] = [10, 20, 50, 100];
  showSearchResultCountModelCari: number[] = [10, 20, 50, 100];
  showSearchCurrentPage = 1;
  showSearchCurrentPageCari = 1;
  showSearchResultText = '';
  showSearchResultTextCari = '';
  kalemAraText = '';
  cariAraText = '';
  searchResults: StokListePage = null;
  searchResultsCari: CariListePage = null;
  kalemAraLoading = false;
  cariAraLoading = false;
  showSelectUrunGrupModalTs: number = null; // farklı id verince açılıyor.
  showYeniCariModalTs: number = null; // farklı id verince açılıyor.
  showTeklifFiyatGecmisiModalTs: number = null; // farklı id verince açılıyor.
  selectedUrunGrup: UrunGrup = null;
  selectedUrunGrupText: string = "";
  yeniCari: Cari = null;
  private subscriptions: Subscription[] = [];
  userGrupId: number;
  talepHareketler: TalepTalepOnaySeviye[] = null;

  DURUM_TEKLIF_TOPLA = Talep.DURUM_TEKLIF_TOPLA;
  DURUM_ONAY_SURECI = Talep.DURUM_ONAY_SURECI;
  teklifIsteFirmalar: Cari[] = [];
  selectedTeslimYeriId = null;
  teslimYerleri: Master[] = null;
  satinAlmaNotu = '';

  TEKLIF_DURUM_INITIAL = Teklif.DURUM_INITIAL;
  TEKLIF_DURUM_CEVAPLANDI = Teklif.DURUM_CEVAPLANDI;
  TEKLIF_DURUM_REVIZE_EDILDI = Teklif.DURUM_REVIZE_EDILDI;
  TEKLIF_DURUM_DEGERLENDIRILDI = Teklif.DURUM_DEGERLENDIRILDI;

  subeler: Sube[] = null;
  talepTurler: TalepTur[] = null;
  urunGruplar: UrunGrup[] = null;
  sarfYeriList: Master[] = null;

  butonYeniCari: boolean = false;

  aciklamaGecmisi: TalepAciklama[];
  // teklifFiyatGecmisi: TeklifFiyatDegisiklik[];
  teklifFiyatGecmisiTeklif: Teklif;

  secilenCari: Cari;
  talepNo: string;
  ACTION_INCELE = TeklifComponent.ACTION_INCELE;
  ACTION_TEKLIF_REVIZE = TeklifComponent.ACTION_TEKLIF_REVIZE;

  ACTION_TEKLIF_ISTE = 'talep-iste';
  ACTION_TEKLIFLER = 'true';
  teklifIsteGosterGizle: boolean = false;
  tekliflerVisible: boolean = false;
  publicAccessKey: Pair[] = [];

  constructor(private authService: AuthService,
    private restService: RestService,
    private router: Router,
    private route: ActivatedRoute,
    private toastrService: ToastrService) {
  }

  ngOnInit(): void {
    this.userGrupId = this.authService.getUser().kullaniciGrupId;
    this.subscriptions.push(this.route.queryParams.subscribe(params => {
      this.id = params.id;

      if (this.ACTION_TEKLIF_ISTE === params.action)
        this.teklifIsteGosterGizle = true;

      if (this.ACTION_TEKLIFLER === params.teklifler)
        this.tekliflerVisible = true;

      if (!params.id) {
        this.id = '0';
      }
      if (this.id === '0') {
        this.talep.id = null;
        this.talep.teslimYeriId = null;
        this.talep.subeId = null;
        this.talep.talepTurId = null;
        this.talep.urunGrupId = null;
        this.talep.aciklama = '';
        this.talep.talepKalemler = [];
        this.talep.talepGorseller = [];
      } else {
        this.getTalepDetails();
      }
    }));
    this.getMaster();
    this.getKullaniciSubeler();
    this.getTalepTurler();
    this.getUrunGruplar();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  kalemAra() {
    debugger
    if (this.showSearchResultCount < 1) {
      this.showSearchResultCount = 10;
    }
    if (this.showSearchResultCount > 100) {
      this.showSearchResultCount = 100;
    }
    if (this.kalemAraText.length > 3) {
      this.kalemAraLoading = true;
      setTimeout(() => {
        this.kalemAraLoading = false;
      }, 10000);
      this.searchResults = null;
      this.restService.kalemAra(this.kalemAraText, -1, this.showSearchCurrentPage, this.showSearchResultCount).subscribe(res => {
        debugger
        if (res) {
          this.searchResults = res;
          this.showSearchResultText = this.kalemAraText;
        }
        this.kalemAraLoading = false;
      });
    }
  }

  showPreviousPageSearchResults() {
    this.showSearchCurrentPage--;
    this.kalemAra();
  }

  showNextPageSearchResults() {
    this.showSearchCurrentPage++;
    this.kalemAra();
  }

  kalemAraInputChange() {
    this.showSearchCurrentPage = 1;
    this.kalemAra();
  }

  removeFromRequestList(rowId: number) {
    $('#cart' + rowId).addClass('target2-highlight');
    setTimeout(() => {
      $('#cart' + rowId).removeClass('target2-highlight');
      this.talep.talepKalemler.splice(rowId, 1);
    }, 1000);

  }

  addToRequestList(k: StokListe, rowId: string) {
    if (k.talepEdilen === null || k.sarfYeriId === undefined) {
      this.toastrService.warning("Tüm alanlar zorunludur!");
      return;
    }
    debugger
    const index = this.talep.talepKalemler.findIndex(x => x.stokKodu === k.stokKodu && x.stokAdi === k.stokAdi && x.sarfYeriId === k.sarfYeriId);
    if (index !== -1) {
      this.talep.talepKalemler[index].talepEdilen += k.talepEdilen;
    } else {
      const item = new TalepKalem();
      item.olcuBirimi = k.olcuBirimi;
      item.talepEdilen = k.talepEdilen;
      item.stokKodu = k.stokKodu;
      item.stokAdi = k.stokAdi;
      item.sonAlisFiyati = k.sonAlisFiyati;
      item.dovizAciklama = k.dovizAciklama;
      item.dovizTipi = k.dovizTipi;
      item.gecenSure = k.gecenSure;
      item.sarfYeriId = k.sarfYeriId;
      item.paraBirimiId = k.dovizTipi;

      this.talep.talepKalemler.push(item);
    }
    $('#' + rowId).addClass('target-highlight');
    setTimeout(() => {
      $('#' + rowId).removeClass('target-highlight');
    }, 3000);
  }

  save() {
    this.talep.urunGrupId = this.selectedUrunGrup?.id;
    if (this.talep.subeId == null) {
      alert('Lütfen şube seçiniz!');
      return;
    }
    if (this.talep.talepTurId == null) {
      alert('Lütfen talep türü seçiniz!');
      return;
    }
    if (this.talep.urunGrupId == null) {
      alert('Lütfen ürün grubunu seçiniz!');
      return;
    }

    const isNewParam = this.talep.id === null ? '1' : '0';
    const request = new TalepKaydetRequest();

    request.id = this.talep.id;
    request.subeId = this.talep.subeId;
    request.talepTurId = this.talep.talepTurId;
    request.urunGrupId = this.talep.urunGrupId;
    request.teslimYeriId = this.talep.teslimYeriId;
    // request.aciklama = this.talep.aciklama;
    request.teslimYeri = this.talep.teslimYeri;
    request.talepKalemler = this.talep.talepKalemler;
    request.talepGorseller = this.talep.talepGorseller;
    request.urunGrupText = this.selectedUrunGrupText;

    if (request.talepTurId === 3) {
      request.cariId = this.secilenCari?.id;
    }
    else {
      request.cariId = null;
    }

    if (this.talep.aciklama !== "" && this.talep.aciklama != null) {
      request.talepAciklama = new TalepAciklama();
      request.talepAciklama.aciklama = this.talep.aciklama;
    }

    this.restService.talepKaydet(request).subscribe(res => {
      debugger
      if (res) {
        // console.log(res);
        if (isNewParam !== "0") {
          const mailRequest = new MailRequest();
          mailRequest.subject = "YENİ TALEP OLUŞTURULDU ( " + res.talepNo + " - " + res.urunGrupText + " )";
          mailRequest.template = MailRequest.YENI_TALEP_FORMU;
          mailRequest.talepId = res.id;

          this.restService.mailGonder(mailRequest).subscribe(res2 => {
          });

          this.router.navigate(['talep-olusturuldu'], { queryParams: { id: res.id, isNew: isNewParam, talepNo: res.talepNo } });
        }
        else
          this.toastrService.show("Değişiklik kaydedildi.", "Başarılı");
      }
    });
  }

  onFileChanged(event): void {
    const file = event.target.files[0];
    this.restService.uploadFile(file).subscribe(res => {
      if (res != null && res.file != null) {
        const gorsel = new TalepGorsel();
        gorsel.dosya = res.file;
        this.talep.talepGorseller.push(gorsel);
      }
    });
  }

  removeGorsel(index: number) {
    this.talep.talepGorseller.splice(index, 1);
  }

  downloadFile(fileName: string) {
    this.restService.downloadFile(fileName).subscribe(res => {

    });
  }

  showSelectUrunGrup() {
    this.showSelectUrunGrupModalTs = new Date().getTime();
  }

  showCariKayitModal() {
    this.showYeniCariModalTs = new Date().getTime();
  }

  yeniCariEkle(event: Cari) {
    if (event) {
      this.addCari(event);
      //this.yeniCari = event;
    }
  }

  selectUrunGrup(event: UrunGrup) {
    if (event) {
      this.selectedUrunGrup = event;
      if (this.selectedUrunGrup.parent === null)
        this.selectedUrunGrupText = this.selectedUrunGrup.isim;
      else if (this.selectedUrunGrup.childrens.length === 0)
        this.selectedUrunGrupText += " -- " + this.selectedUrunGrup.isim;
    }
  }

  getTalepDetails() {
    this.restService.talepDetaylar(this.id).subscribe(res => {
      if (res) {
        this.talep = res;
        this.talepNo = res.talepNo;
        this.selectedUrunGrup = res.urunGrup;
        this.selectedUrunGrupText = this.talep.urunGrupText;
        this.aciklamaGecmisi = res.talepAciklamalar;
        this.secilenCari = res.cari;

        this.restService.getTalepHareketler(this.id).subscribe(res2 => {
          this.talepHareketler = res2;
        });
      }
    });
  }

  talepOnayla(id: number, isOnay: boolean) {
    const request = new TalepOnaylaRequest();
    request.talepId = this.talep.id;
    request.talepOnaySeviyeId = id;
    request.isOnay = isOnay;
    this.restService.talepOnayla(request).subscribe(res => {
      this.getTalepDetails();
    });
  }

  addCari(c: Cari) {
    if (this.teklifIsteFirmalar.findIndex(x => x.id === c.id) !== -1) {
      alert('Bu firma zaten eklendi');
      return;
    }
    this.teklifIsteFirmalar.push(c);
  }

  cariSec(c: Cari) {
    this.secilenCari = c;
    this.cariAraText = "";
    this.searchResultsCari = null;
  }

  cariAra() {
    if (this.showSearchResultCountCari < 1) {
      this.showSearchResultCountCari = 10;
    }
    if (this.showSearchResultCountCari > 20) {
      this.showSearchResultCountCari = 20;
    }
    if (this.cariAraText.length > 3) {
      this.cariAraLoading = true;
      setTimeout(() => {
        this.cariAraLoading = false;
      }, 10000);
      this.searchResultsCari = null;
      this.restService.cariAra(this.cariAraText, this.showSearchCurrentPageCari, this.showSearchResultCountCari).subscribe(res => {
        if (res) {
          this.searchResultsCari = res;
          this.showSearchResultTextCari = this.cariAraText;

          if (res.results.length === 0)
            this.butonYeniCari = true;
          else
            this.butonYeniCari = false;
        }
        this.cariAraLoading = false;
      });
    }
  }

  showPreviousPageSearchResultsCari() {
    this.showSearchCurrentPageCari--;
    this.cariAra();
  }

  showNextPageSearchResultsCari() {
    this.showSearchCurrentPageCari++;
    this.cariAra();
  }

  cariAraInputChange() {
    this.showSearchCurrentPageCari = 1;
    this.cariAra();
  }

  removeCari(index: any) {
    this.teklifIsteFirmalar.splice(index, 1);
  }

  fiyatIste() {
    if (this.selectedTeslimYeriId == null) {
      alert('Lütfen teslim yeri seçiniz!');
      return;
    }
    const request = new TeklifOlusturRequest();
    request.talepId = this.talep.id;
    for (const c of this.teklifIsteFirmalar) {
      debugger;
      request.cariIdList.push(c.id);

      if (c.epostaGonder) {
        request.mailGonderCariIdList.push(c.id);
      }

      if (c.gorselGoster) {
        request.gorselGosterCariIdList.push(c.id);
      }
    }
    request.satinAlmaNotu = this.satinAlmaNotu;
    request.teslimYeriId = this.selectedTeslimYeriId;

    this.restService.teklifOlustur(request).subscribe(res => {
      if (res) {
        const mailRequest = new MailRequest();
        mailRequest.subject = "TEKLİF İSTEME FORMU";
        mailRequest.template = MailRequest.TEKLIF_ISTEME_FORMU;

        for (let teklif of res) {
          if (teklif.mailGonder) {
            debugger;
            this.publicAccessKey.push(new Pair(teklif.cariId, teklif.publicAccessKey));

            this.restService.cariDetay(teklif.cariId).subscribe(cari => {
              mailRequest.publicAccessKey = this.publicAccessKey.filter(x => x.key == cari.id).map(x => x.value).toString();
              mailRequest.name = cari.firmaUnvani;
              mailRequest.toEmail = cari.mailAdresi;
              mailRequest.talepNo = this.talepNo;

              this.restService.mailGonder(mailRequest).subscribe(res2 => {
                if (!res2) {
                  this.toastrService.error("Mail gönderilirken hata oluştu");
                }
              });
            });
          }
        }
      }
      this.router.navigate(['teklifler']);
    });
  }

  getMaster() {
    const types = [
      Master.TeslimYeri,
      Master.SarfYeri
    ];
    this.restService.getMasterTypes(types).subscribe(res => {
      this.teslimYerleri = res?.TeslimYeri?.map(x => new Master(x));
      this.sarfYeriList = res?.SarfYeri?.map(x => new Master(x));
    });
  }

  teklifMailGonder(t: any) {
    let cari: Cari;
    this.restService.cariDetay(t.cari.id).subscribe(c => {
      if (c) {
        cari = c;
        const mailRequest = new MailRequest();

        mailRequest.subject = "TEKLİF İSTEME FORMU";
        mailRequest.template = MailRequest.TEKLIF_ISTEME_FORMU;
        mailRequest.name = cari.firmaUnvani;
        mailRequest.toEmail = cari.mailAdresi;
        mailRequest.talepNo = this.talepNo;
        mailRequest.publicAccessKey = t.publicAccessKey;

        this.restService.mailGonder(mailRequest).subscribe(res => {
          if (res) {
            this.restService.mailGonderildi(t.id).subscribe(res => {
              this.getTalepDetails();
            })
          }
        })
      }
      else
        this.toastrService.error("Cari Bulunamadı!", "Hata");
      return;
    })

  }

  teklifDetay(t: Teklif) {
    this.router.navigate(['teklif'], { queryParams: { id: t.id.toString() } });
  }

  teklifGir(t: Teklif) {
    this.router.navigate(['teklif'], { queryParams: { id: t.id.toString(), action: 'teklif-gir' } });
  }

  getKullaniciSubeler() {
    this.restService.kullaniciSubeleri().subscribe(res => {
      this.subeler = res;
      const subeler = this.authService.getSelectedSubeIdList();
      if (subeler != null && subeler.length === 1 && this.subeler.findIndex(x => x.id === subeler[0]) !== -1) {
        this.talep.subeId = subeler[0];
      }
    });
  }

  getTalepTurler() {
    this.restService.talepTurler().subscribe(res => {
      this.talepTurler = res;
    });
  }

  getUrunGruplar() {
    this.restService.urunGruplar(null).subscribe(res => {
     
      this.urunGruplar = res.sort(function(a, b) {
        var textA = a.isim.toUpperCase();
        var textB = b.isim.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
     
    });
  }


  incele(t: Teklif, actionParam: string = this.ACTION_INCELE) {
    debugger;
    this.router.navigate(['teklif'], { queryParams: { id: t.id, action: actionParam } });
  }

  showTeklifFiyatGecmisi(teklifId: number) {
    this.restService.teklif(teklifId).subscribe(res => {
      if (res) {
        this.teklifFiyatGecmisiTeklif = res;
        this.showTeklifFiyatGecmisiModalTs = new Date().getTime();
        // this.restService.getTeklifFiyatDegisiklik(teklifId).subscribe(res => {
        //   if (res) {
        //     this.teklifFiyatGecmisi = res;
        //   }
        // });
      }
    });
  }

  kalemKaldir() {
    const request = new TalepKaydetRequest();

    request.id = this.talep.id;
    request.talepKalemler = this.talep.talepKalemler;
    this.restService.talepKalemKaldir(request).subscribe(res => {
      this.toastrService.success("Kayıt Başarılı!");
    });
  }
}
